export { default } from './CodingListLayout';
